import { ReactNode } from 'react';

type CustomObjectsContainerProps = {
  children: ReactNode;
};
export function CustomObjectsContainer({
  children,
}: CustomObjectsContainerProps) {
  return <div className="m-4 lg:m-8">{children}</div>;
}
